import QuickOrder from 'browse/quickorder/QuickOrder';
import search from 'browse/search/search';
import initWidgets from 'browse/algolia/algoliaInstantSearch/initWidgets';
import hybrisEnrichment from 'browse/algolia/hybrisEnrichment';
import productBundles from 'browse/productBundles';
import productDescriptionAnchor from 'browse/productDescriptionAnchor';
import productDetails from 'browse/productDetails';
import ProductHeader from 'browse/ProductHeader';
import { productDynamicAttributes } from 'browse/productDynamicAttributes';
import productVariantSelector from 'browse/productVariantSelector';
import ProductRating from 'browse/ProductRating';
import productCarousel from 'browse/productCarousel';
import ImageViewer from 'browse/imageViewer';
import ParagraphExpander from 'global/common/paragraphExpander';
import MultiImageViewer from 'browse/multiImageViewer';
import ProductCompare from 'browse/compare/productCompare';
import inkTonerFinderResultsPage from 'browse/inkAndTonerResults/inkTonerFinderResultsPage';
import InkTonerSwitcher from 'browse/inkAndTonerResults/inkTonerSwitcher';
import SearchForm from 'global/search/SearchForm';
import MyPrintersCarousel from 'browse/inkAndTonerResults/myPrintersCarousel';
import AlternativeProductsLabelsDisplay from 'browse/alternativeProductsLabelsDisplay';

const quickOrderPage = document.getElementById('quickOrderWrap');
new QuickOrder(quickOrderPage);

const resultsPage = document.getElementById('resultsPage');
search(resultsPage);

const algoliaSearchResultsPage = document.querySelector(
	'.algolia-search-list-page',
);
if (algoliaSearchResultsPage) {
	window.hybrisEnrichment = hybrisEnrichment;
	window.hybrisEnrichment.init();
	initWidgets();
	window?.od?.events?.subscribe(
		'algolia_hybrisEnrichment_renderedProductTiles',
		() => {
			$('[data-toggle="tooltip"]').tooltip();
		},
	);
}

const myPrintersCarouselElem = document.getElementById('myPrintersCarousel');
if (window.od.myPrinters && myPrintersCarouselElem) {
	new MyPrintersCarousel(myPrintersCarouselElem);
}

new ImageViewer('s7viewer');

const multiImageViewerBlock = document.querySelector(
	'.js-multi-image-viewer-block',
);
if (multiImageViewerBlock) {
	new MultiImageViewer(multiImageViewerBlock).init();
}

productVariantSelector();
new ProductRating();

productDynamicAttributes();
productDetails();
productCarousel();

const header = document.getElementById('productHeader');
new ProductHeader(header);

productDescriptionAnchor();

const bundles = document.getElementById('productPerfectPartnerBundles');
productBundles(bundles);

new ProductCompare();

const searchOptions = (window.od && window.od.searchOptionsInkToner) || {};
new SearchForm(searchOptions);

const inkTonerSwitcherWrapper = document.getElementById('inkTonerSwitcher');
new InkTonerSwitcher(inkTonerSwitcherWrapper);

const inkTonerFinderResultsPageElem = document.getElementById(
	'inkTonerFinderResultsPage',
);

inkTonerFinderResultsPage(inkTonerFinderResultsPageElem);

search(inkTonerFinderResultsPageElem);

new ParagraphExpander();

const alternativeProductsBlock = document.querySelectorAll(
	'.js-alternative-products',
);
if (alternativeProductsBlock) {
	alternativeProductsBlock.forEach(block => {
		new AlternativeProductsLabelsDisplay(block).init();
	});
}
